const METHOD_OPTIONS = ['GET', 'POST', 'PUT', 'PATCH', 'DELETE', 'HEAD', 'OPTIONS']
  .map(value => ({ label: value, value }));

module.exports = () => {
  return {
    // 请求时间范围
    date: {
      label: '请求时间',
      type: 'date-picker',
      props: {
        size: 'mini',
        type: 'datetimerange',
        rangeSeparator: '至',
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        valueFormat: 'yyyy-MM-dd HH:mm:ss',
        format: 'yyyy-MM-dd HH:mm:ss',
      },
      value: [],
    },
    // 请求账号
    username: {
      label: '请求账号',
      type: 'input',
      props: {
        placeholder: '请输入账号',
      },
      value: '',
    },
    // 请求类型（多选）
    methods: {
      label: '请求类型',
      type: 'select',
      props: {
        placeholder: '请选择请求类型',
        multiple: true,
        filterable: true,
      },
      options: METHOD_OPTIONS,
      value: [],
    },
    // 请求地址
    path: {
      label: '请求地址',
      type: 'input',
      props: {
        placeholder: '请输入请求地址',
      },
      value: '',
    },
    // 请求 IP
    ip: {
      label: '请求IP',
      type: 'input',
      props: {
        placeholder: '请输入请求IP',
      },
      value: '',
    },
    // 响应状态码（多选，支持输入多个，以逗号或空格分隔）
    status_codes: {
      label: '响应状态码',
      type: 'input',
      props: {
        placeholder: '请输入状态码，多个用逗号分隔',
      },
      value: '',
    },
    // 最小请求耗时（毫秒），筛选慢请求
    min_duration: {
      label: '最小耗时',
      type: 'input',
      props: {
        placeholder: '请输入最小耗时(ms)',
      },
      value: '',
    },
  };
};
